//Dependecies
import React, { useEffect } from 'react';
import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { isMobile } from 'react-device-detect';
//Databases
import dimensions from '../../databases/app/dimensions';
import branches from '../../databases/branches';
//Components
import Drawer01 from '../components/drawers/Drawer01';
import Map01 from '../components/maps/Map01';
import Menu01 from '../components/menus/Menu01';
import Modal01 from '../components/modals/Modal01';
import Navbar01 from '../components/navbars/Navbar01';
import Searchbar01 from '../components/searchbars/SearchBar01';
import Sidemenu01 from '../components/sidemenus/Sidemenu01';
//Actions
import { GetMarkers } from '../../store/actions/LoadingActions';

const MainRouter = () =>
{
  const dispatch = useDispatch(); 

  /* DIMENSIONS */
  const height = window.innerHeight;
  const width = window.innerWidth;
  
  let { id } = useParams();
  const locationURL = useLocation();

  const location = useSelector(state => state.map.location);
  const center = useSelector(state => state.map.center);
  const zoom = useSelector(state => state.map.zoom);
  const layers = useSelector(state => state.map.layers); 

  const markersDB = useSelector(state => state.markers.markersDB);
  const selected = useSelector(state => state.markers.selected);
  const selectedBranches = useSelector(state => state.markers.selectedBranches);
  const last = useSelector(state => state.markers.last);

  const loading = useSelector(state => state.app.loading);

  const params = new URLSearchParams(locationURL.search);
  const filter = params.get('f');
  const influencer = params.get('by');
  const branch = params.get('s');

  /* LOADING MARKERS */
  useEffect(() => 
  {
    dispatch(GetMarkers());    
  }, [dispatch]);

  /* CHECK ID */
  useEffect(() => 
  {
    try 
    {
      if(markersDB && id)
      {
        const markerID = Object.keys(markersDB).filter(f1 => markersDB[f1].info.username === id);      

        if(markerID.length === 1)
        {
          let data = markersDB[markerID];

          dispatch({type: 'SET_CENTER', center : data.info.location});

          if(zoom < 14 )
          {
            dispatch({type: 'SET_ZOOM', zoom : 14});
          }

          setTimeout(() => 
          {
            dispatch({type: 'SET_DRAWER_01', drawer01 : true});
          }, 200);

          setTimeout(() => 
          {
            dispatch({type: 'SET_MARKERS_SELECTED', selected : data});
            dispatch({type: 'SET_LAST', last : data});
          }, 400); 
        }
        else if (markerID.length > 1)
        {
          let branchsArray = [];

          for (let i = 0; i < markerID.length; i++) 
          {
            let branchData = markersDB[markerID[i]];
            
            branchsArray.push(branchData);          
          }
          
          if(branch)
          {
            let branchID = Object.keys(branchsArray).find(f1 => branchsArray[f1].info.branchurl === branch);
            let data = branchsArray[branchID];

            dispatch({type: 'SET_CENTER', center : data.info.location});
            if(zoom < 14 )
            {
              dispatch({type: 'SET_ZOOM', zoom : 14});
            }
            dispatch({type: 'SET_MARKERS_SELECTED_BRANCHES', selectedBranches : branchsArray});

            setTimeout(() => 
            {
              dispatch({type: 'SET_DRAWER_01', drawer01 : true});
            }, 200);
            
            setTimeout(() => 
            {
              dispatch({type: 'SET_MARKERS_SELECTED', selected : data});
              dispatch({type: 'SET_LAST', last : data});
            }, 400); 
          }
          else
          {
            dispatch({type: 'SET_MARKERS_SELECTED_BRANCHES', selectedBranches : branchsArray});
            dispatch({type: 'SET_CENTER', center : branches[id].center});
            dispatch({type: 'SET_ZOOM', zoom : branches[id].zoom});
          }
        }
        else
        {
          toastr.error("VIVE EN 360", 'LOCAL NO ENCONTRADO');
        }
      }
      else
      {
        dispatch({type: 'SET_MARKERS_SELECTED_BRANCHES', selectedBranches : null});
        dispatch({type: 'SET_MARKERS_SELECTED', selected : null});
        dispatch({type: 'SET_DRAWER_01', drawer01 : false});
      }

      dispatch({type: 'LOADING', loading : false});
    } 
    catch (error) 
    {
      console.log(error);
    } 
  }, [branch, id, influencer, markersDB, zoom, dispatch]);

  if(loading) return(
    <Menu01
      height        = {Math.round(dimensions.menu * height / 100)}
      id            = {id}
      filter        = {filter}
      influencer    = {influencer}
      visible       = {true}
    />
  )

  return(
    <React.Fragment>
      <Navbar01
        title   = {'vive en 360'}
        height  = {Math.round(dimensions.navbar * height / 100)}
        visible = {true}
      />

      <Map01
        location      = {location}
        height        = {window.innerHeight}
        center        = {center}
        zoom          = {zoom}
        paddingTop    = {Math.round(dimensions.navbar * height / 100)}
        paddingBottom = {Math.round(dimensions.menu * height / 100)}
        visible       = {true}
        markers       = {markersDB}

        influencer    = {influencer}
        branches      = {selectedBranches}
        filter        = {filter}

        last          =   {last}
      />

      <Drawer01
        data          = {selected}
        influencer    = {influencer}
        filter        = {filter}
        branches      = {selectedBranches}
        isMobile      = {isMobile}
      />

      <Modal01
        title         = {'nombre del local'}
        height        = {Math.round(dimensions.modal01 * height / 100)}
        width         = {Math.round(95 * width / 100)}
        visible       = {true}
        isMobile      = {isMobile}
      />

      <Searchbar01
        text          = {'BUSCA EL LOCAL'}
        height        = {Math.round(dimensions.navbar * height / 100)}
        width         = {dimensions.searchbar}
        visible       = {true}

        markers       = {markersDB}
      />

      <Sidemenu01
        height        = {Math.round(dimensions.menu * height / 100)}
        layers        = {layers}
        visible       = {true}
        isMobile      = {isMobile}
      />    
    
      <Menu01
        height        = {Math.round(dimensions.menu * height / 100)}
        id            = {id}
        filter        = {filter}
        influencer    = {influencer}
        visible       = {true}
      />
    </React.Fragment>
  );
}

export default MainRouter;